import React, { useEffect, useState } from "react";
import { SiEthereum } from "react-icons/si";
import { useNavigate } from "react-router-dom";
import { useSwitchNetwork } from "wagmi";
import { NavLink } from "react-router-dom";
import { FaJediOrder } from "react-icons/fa";
import { SiBinance } from "react-icons/si";
import { useSigner, useNetwork, useAccount } from "wagmi";
import { TokenBalancebyWallet } from "../Services/Moralis";
import { getWallwtChainBalance } from "../Services/Moralis";
import MyAccount from "./MyAccount";
import Spinner from "../Components/Spinner";
import {getUsdBalance} from "../Services/CryptoCompare"
const SendCoin = () => {
  //------------useStates-----------------------------//
  const [activeTab, setActiveTab] = useState("bitcoin");
  const [balance, setBalance] = useState("0");
  const [ercTokenBalance, setercTokenBalance] = useState();
  const [etherBalance, setEtherBalance] = useState();
  const [bscBalance, setBscBalance] = useState();
  const [balanceloading,setbalanceLoading] = useState(true)
  const [pricing,setPricing] = useState([]);
  const navigate = useNavigate();

  //-------------wagmi-Hooks----------------------//
  const { switchNetwork } = useSwitchNetwork();
  const { chain } = useNetwork();
  const { data: signer } = useSigner();
  const { connector: activeConnector, isConnected } = useAccount()


  //---------------------useEffect_HOOK-----------------------------------------//
  useEffect(() => {
   if(signer && isConnected)
   {
    getUsdBalance().then((_res)=>{
      
      setPricing(_res);
      setbalanceLoading(false);
      
    })
    if (chain.id === 97) {

     
        getAddress().then(async (_response) => {
          //---BEP------//
          TokenBalancebyWallet(
            "bsc%20testnet",
            _response,
            "0x8083f306F987fd6965b1Cec9EaFc4e7Ac64B6c5c"
          ).then((_bepBalance) => {
            
            setercTokenBalance(_bepBalance);
            localStorage.setItem("DioSend",_bepBalance);
          });
        });
      
    } else {
     
     
        getAddress().then(async (_response) => {
          //---BEP------//
          TokenBalancebyWallet(
            "sepolia",
            _response,
            "0x776820f1a6adbED4B790EA58a01Af2d5F7E02967"
          ).then((_bepBalance) => {
       
            setercTokenBalance(_bepBalance);
            localStorage.setItem("DioSend",_bepBalance);
          });
        });
      
    }
  
    getAddress().then((_response) => {
      getWalletBalances(_response);
    });
  }
  }, [chain, signer, isConnected]);


//-----------------get_balance-of-chians--------------------------------//
const getWalletBalances = async (address) => {
 

  getWallwtChainBalance("bsc%20testnet", address).then((_balance) => {
    setBscBalance(_balance);
  });

  getWallwtChainBalance("sepolia", address).then((_balance) => {
  
    setEtherBalance(_balance);
  });

  return 0;
};




  //-------------------Changing-TABS--------------------//
  const handleTabClick = (tab) => {
    if (tab === "bitcoin") {
      switchNetwork?.(97);
    } else if(tab ==="ethereum") {
      switchNetwork?.(11155111);
    }else{}

    setActiveTab(tab);
  };
  //------------get-current-user-address----------------------//

  async function getAddress() {
    const address = await signer.getAddress();
    return address;
  }

  //---------------witch-to-ethereum-Network----------------------//
  const switchtoEhereum = async () => {
    switchNetwork?.(11155111);
    localStorage.setItem("Network", "Ethereum");
    navigate("/form");
  };

  //---------------witch-to-BNB-Network----------------------//
  const switchtoBNB = async () => {
    switchNetwork?.(97)
    localStorage.setItem("Network", "Bnb");
    navigate("/form");
  };

  return (
    <div className="w-full  mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
    <div className=" ">
     {balanceloading?(<div className="flex justify-center items-center">
       <Spinner/>
       <p> Please connect your Wallet...</p>
     </div>):(
      <MyAccount
         Ethbalance={etherBalance}
            bscBalance={bscBalance}
            dioBalance={ercTokenBalance}
            EthUsd = {pricing[0].EthUsd}
      BnbUsd ={pricing[0].BnbUsd}
      />
     )}
    </div>
    
    <div className="lg:col-span-2">
    <div className="grid grid-cols-3  ">
        <button
          className={`${
            activeTab === "bitcoin"
              ? "bg-slate-600 text-white"
              : "bg-gray-300 text-gray-700"
          } flex-1 py-2 sm:rounded-tl-md sm:rounded-bl-md mb-2`}
          onClick={() => handleTabClick("bitcoin")}
        >
          BNB
        </button>
        <button
          className={`${
            activeTab === "ethereum"
              ? "bg-slate-600 text-white"
              : "bg-gray-300 text-gray-700"
          } flex-1 py-2   mb-2`}
          onClick={() => handleTabClick("ethereum")}
        >
          Ethereum
        </button>
        <button
          className={`${
            activeTab === "Dio"
              ? "bg-slate-600 text-white"
              : "bg-gray-300 text-gray-700"
          } flex-1 py-2 sm:rounded-tr-lg sm:rounded-br-lg mb-2`}
          onClick={() => handleTabClick("Dio")}
        >
          Dio
        </button>
      </div>
      {activeTab === "bitcoin" && (
        <div className="bg-slate-100  mt-4 shadow-md  rounded-lg text-center   p-3  mb-4  ">
          <center className="py-4 ">
            {" "}
            <SiBinance size={90} color="yellow" />
          </center>
          <h1 className="text-2xl md:text-5xl"> {bscBalance} BNB</h1>
          <p className="tracking-tight md:tracking-widest md:text-2xl       ">
            {" "}
          </p>
          <div className="flex justify-center gap-6 md:gap-20 py-4 md:py-0 md:pt-14">
            {" "}
            <button
              className="bg-slate-600 rounded-full w-20 md:w-36  h-8 md:h-14 text-white mb-4"
              onClick={switchtoBNB}
            >
              {" "}
              Send
            </button>
            {/* <NavLink to={"/receivebtc"}>
              {" "}
              <button className="bg-slate-600 rounded-full w-20 md:w-36  h-8 md:h-14 text-white mb-4">
                {" "}
                Receive
              </button>
            </NavLink> */}
          </div>
        </div>
      )}
      {activeTab === "ethereum" && (
        <div className="bg-slate-100  mt-4 shadow-md  rounded-lg text-center   p-3  mb-4  ">
          <center className="py-4 ">
            {" "}
            <SiEthereum size={90} color="blue" />
          </center>
          <h1 className="text-2xl md:text-5xl"> {etherBalance} Ethereum</h1>
          <p className="tracking-tight md:tracking-widest md:text-2xl       ">
            {" "}
          </p>
          <div className="flex justify-center gap-6 md:gap-20 py-4 md:py-0 md:pt-14">
            <button
              className="bg-slate-600 rounded-full w-20 md:w-36 h-8 md:h-14 text-white"
              onClick={switchtoEhereum}
            >
              {" "}
              Send
            </button>
            {/* <NavLink to={"/receivebtc"}>
              {" "}
              <button className="bg-slate-600 rounded-full w-20 md:w-36  h-8 md:h-14 text-white mb-4">
                {" "}
                Receive
              </button>
            </NavLink> */}
          </div>
        </div>
      )}
      {activeTab === "Dio" && (
        <div className="bg-slate-100  mt-4 shadow-md  rounded-lg text-center   p-3  mb-4  ">
          <center className="py-4 ">
            {" "}
            <FaJediOrder size={90} color="purple" />
          </center>
          <h1 className="text-2xl md:text-5xl"> {ercTokenBalance} Dio</h1>
          <p className="tracking-tight md:tracking-widest md:text-2xl       ">
            {" "}
          </p>
          <div className="flex justify-center gap-6 md:gap-20 py-4 md:py-0 md:pt-14">
            <NavLink to={"/senddio"}>
              <button className="bg-slate-600 rounded-full w-20 md:w-36 h-8 md:h-14 text-white">
                {" "}
                Send
              </button>
            </NavLink>
            {/* <NavLink to={"/receivebtc"}>
              {" "}
              <button className="bg-slate-600 rounded-full w-20 md:w-36  h-8 md:h-14 text-white mb-4">
                {" "}
                Receive
              </button>
            </NavLink> */}
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default SendCoin;
